import { API_URL, API_TOKEN } from "../api/apiConfig";

export const fetchMeetupspagepastlist = async () => {
  try {
    const response = await fetch(`${API_URL}/pastupcoming_meetupslist`, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      },
    });

    return await response.json();
  } catch (error) {
    console.log("Meetupspastlist API Error:", error);
    return null;
  }
};
